/// <amd-module name="Artifacts/FeedSettings/types/IFeedSettings" />
import { IFeedRetentionSettings } from "Artifacts/FeedSettings/types/IFeedRetentionSettings";
import { IUpstreamSource } from "Artifacts/FeedSettings/types/IUpstreamSource";
import { FeedView } from "Artifacts/Root/web-apis/contracts/Feed";
import { UpstreamHealthStatus } from "Artifacts/Root/web-apis/contracts/WebPage";

/// <amd-module name="Artifacts/FeedSettings/types/IFeedSettings" />
export interface IFeedSettings {
  /**
   * Default public upstream sources.
   */
  defaultPublicUpstreams: IUpstreamSource[];
  /**
   * The view that the feed administrator has indicated is the default experience for readers.
   */
  defaultViewId: string;
  /**
   * A description for the feed.  Descriptions must not exceed 255 characters.
   */
  description: string;
  /**
   * A GUID that uniquely identifies this feed.
   */
  feedId: string;
  /**
   * A name for the feed.
   */
  feedName: string;
  /**
   * True if permissions should support service principals
   */
  supportServicePrincipals: boolean;
  /**
   * If set, the feed will hide all deleted/unpublished versions
   */
  hideDeletedPackageVersions: boolean;
  /**
   * Flag to indicated whether the Org is backed by AAD
   */
  isOrgAadBacked: boolean;
  /**
   * If set, this feed supports generation of package badges.
   */
  isBadgesEnabled: boolean;
  /**
   * Retention settings for the feed
   */
  retention: IFeedRetentionSettings;
  /**
   * The date that this feed is scheduled to be permanently deleted.
   */
  scheduledPermanentDeleteDate?: Date;
  /**
   * Upstream sources for the feed, sorted by the upstream index.
   */
  upstreamSources: IUpstreamSource[];
  /**
   * Status of the feed's upstream sources
   */
  upstreamStatuses?: UpstreamHealthStatus[];
  /**
   * Views of the feed.
   */
  views: FeedView[];
}
